import { TagInput as BaseTagInput } from 'components/TagInput/TagInput'
import Styles from './BrandVoice.module.scss'

interface TagInputProps {
  value: string | string[]
  name: string
  placeholder: string
  onChange: (value: Set<string>) => void
  hideAddButton?: boolean
  showRemoveButton?: boolean
}

export const TagInput = ({
  name,
  value,
  placeholder,
  onChange,
  hideAddButton = false,
  showRemoveButton = true,
}: TagInputProps) => {
  const tags = Array.isArray(value) ? value : [value]

  return (
    <BaseTagInput
      aria-label={name}
      maxWidth
      tags={tags}
      onChange={(newTags) => onChange(new Set(newTags))}
      placeholder={placeholder}
      useAddPill={!hideAddButton}
      showRemoveButton={showRemoveButton}
      inputWithBorder
      size="md"
      wrapperClassName={Styles.tagInputContainer}
    />
  )
}
